/* =====================================================================
   Purelly · comportamentos próprios sobre o Dawn (15/10/2026)
   1) Carrinho: o bundle do Kaching (linha paga + linha de brinde) se comporta como UMA escolha.
      − / + pulam entre as ofertas (1 · 3 · 5) e a lixeira remove o bundle inteiro. Cada troca AJUSTA
      as linhas existentes (/cart/change.js) com as propriedades que o botão de compra do Kaching grava,
      então o preço continua calculado pelo Kaching, o − não gera AddToCart e o + só manda as unidades a mais.
      Os brindes de outro produto (as guias do alho) acompanham a oferta: saem os da oferta antiga e entram
      os da nova, no mesmo grupo das unidades (senão passam a ser cobrados).
   2) Barra fixa de compra na página de produto.
   3) Página /cart com o mesmo carrinho da gaveta.
   ===================================================================== */
(function () {
  if (window.__plBundle) return;
  window.__plBundle = true;

  // só usado se a API do Kaching não responder
  var OFERTAS_RESERVA = {
    xxRj: [
      { id: '9ca5e80f-c07c-44d9-b569-0effbc6bb620', t: 'quantity-break', q: 1, presentes: [] },
      { id: 'ce8812cb-c35a-421e-99ee-0ae84405e223', t: 'bxgy', buy: 2, get: 1, presentes: [] },
      { id: 'ad970f0d-db26-40e0-b433-c8851fb695d2', t: 'bxgy', buy: 3, get: 2, presentes: [] },
    ],
    // óleo de abóbora (16/10)
    dU1i: [
      { id: '6f4cd2e3-9c64-4f58-a250-c84e445529f1', t: 'quantity-break', q: 1, presentes: [] },
      { id: 'e3d532a8-3235-4fe7-ad04-35345809d9f8', t: 'bxgy', buy: 2, get: 1, presentes: [] },
      { id: 'fb814ba3-4eb3-4f2b-bba4-c03e074e1775', t: 'bxgy', buy: 3, get: 2, presentes: [] },
    ],
    // alho: as guias entram de brinde no 2+1 (1 guia) e no 3+2 (2 guias)
    YpK7: [
      { id: '6ZTW', t: 'quantity-break', q: 1, presentes: [] },
      { id: 'bN3a', t: 'bxgy', buy: 2, get: 1, presentes: [{ id: 'dezi', produto: 9547491639539, q: 1 }] },
      { id: 'fcw6', t: 'bxgy', buy: 3, get: 2, presentes: [{ id: 'RJTa', produto: 9547491639539, q: 1 }, { id: 'jzd7', produto: 9547492720883, q: 1 }] },
    ],
  };
  // produto → variante dos brindes, se /products.json não responder
  var VARIANTES_RESERVA = { 9547491639539: 49111037247731, 9547492720883: 49111040721139 };
  var raiz = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

  function post(url, corpo) {
    return fetch(raiz + url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(corpo),
    }).then(function (r) {
      if (!r.ok) throw new Error(url + ' ' + r.status);
      return r.json();
    });
  }
  function ofertas(deal) {
    var api = window.kachingBundlesApi;
    var p = api && api.fetchDeals ? api.fetchDeals() : Promise.reject();
    return p
      .then(function (ds) {
        var d = (ds || []).find(function (x) { return x.nanoId === deal; });
        if (!d || !d.dealBars || !d.dealBars.length) throw 0;
        return d.dealBars.map(function (b) {
          var presentes = (b.freeGifts || [])
            .filter(function (g) { return g.productId || g.variantId; })
            .map(function (g) {
              return { id: g.id, produto: g.productId, variante: g.variantId || (g.variantIds && g.variantIds[0]) || null, q: g.quantity || 1, soAssinatura: !!g.applyOnlyForSubscriptions };
            });
          return { id: b.id, t: b.dealBarType, q: b.quantity, buy: b.buyQuantity, get: b.getQuantity, presentes: presentes };
        });
      })
      .catch(function () { return OFERTAS_RESERVA[deal] || null; });
  }
  function unidades(b) { return b.t === 'bxgy' ? (b.buy || 0) + (b.get || 0) : b.q || 0; }

  // variante de cada produto de brinde (o Kaching só informa o produto)
  var variantes = null;
  function varianteDe(produto, cart) {
    var naCesta = cart && cart.items.find(function (i) { return String(i.product_id) === String(produto); });
    if (naCesta) return Promise.resolve(naCesta.variant_id);
    variantes = variantes || fetch(raiz + 'products.json?limit=250')
      .then(function (r) { return r.json(); })
      .then(function (d) {
        var m = {};
        (d.products || []).forEach(function (p) {
          var v = (p.variants || []).find(function (x) { return x.available; }) || (p.variants || [])[0];
          if (v) m[p.id] = v.id;
        });
        return m;
      })
      .catch(function () { return {}; });
    return variantes.then(function (m) { return m[produto] || VARIANTES_RESERVA[produto] || null; });
  }

  // mesmo caminho de renderização que o Dawn usa ao mudar quantidade
  function renderizar(itens, json) {
    var vazio = json.item_count === 0;
    var gaveta = document.querySelector('cart-drawer');
    itens.classList.toggle('is-empty', vazio);
    if (gaveta) gaveta.classList.toggle('is-empty', vazio);
    itens.getSectionsToRender().forEach(function (s) {
      var host = document.getElementById(s.id);
      if (!host || !json.sections || !json.sections[s.section]) return;
      var alvo = host.querySelector(s.selector) || host;
      alvo.innerHTML = itens.getSectionInnerHTML(json.sections[s.section], s.selector);
    });
  }
  function atualizar(itens) {
    return post('cart/update.js', {
      updates: {},
      sections: itens.getSectionsToRender().map(function (s) { return s.section; }),
      sections_url: location.pathname,
    }).then(function (json) { renderizar(itens, json); });
  }
  // update.js só mexe nas linhas: os atributos do carrinho (bb_user_id, fbp, fbc...) ficam intactos
  function zerar(linhas) {
    if (!linhas.length) return Promise.resolve();
    var u = {};
    linhas.forEach(function (i) { u[i.key] = 0; });
    return post('cart/update.js', { updates: u });
  }
  // ?kaching_bundles=true: o interceptador de carrinho do Kaching deixa passar a linha como está
  function adicionar(items) {
    return post('cart/add.js?kaching_bundles=true', { items: items });
  }
  // propriedades que o botão de compra do Kaching grava em cada linha (é delas que sai o preço da oferta)
  function propsDaOferta(bar, base) {
    var grupo = Math.random().toString(36).slice(2, 6);
    var paga = { deal: base.deal, pp: base.pp, main: true, v: base.v };
    if (base.sellingPlan) paga.sellingPlan = base.sellingPlan;
    paga.id = grupo;
    if (bar.t !== 'bxgy') { paga.bid = bar.id; return { grupo: grupo, pagas: bar.q, paga: paga, brindes: 0, brinde: null }; }
    paga.bar = bar.id;
    return { grupo: grupo, pagas: bar.buy, paga: paga, brindes: bar.get, brinde: { id: grupo, deal: base.deal, bar: bar.id, v: base.v, main: true, bxgy: true } };
  }
  function propsDe(i) {
    try { return JSON.parse((i.properties || {}).__kaching_bundles || 'null'); } catch (e) { return null; }
  }
  // Relê o carrinho a cada passo: quando o Kaching recalcula o desconto, as chaves das linhas mudam.
  // Partes da mesma linha (mesma chave) são somadas. Os brindes de outro produto (guias) vêm à parte.
  function linhasAtuais(variante) {
    return fetch(raiz + 'cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var m = {}, ordem = [], presentes = [];
        cart.items.forEach(function (i) {
          var p = propsDe(i);
          if (p && p.gift) { presentes.push({ key: i.key, quantidade: i.quantity, props: p, item: i }); return; }
          if (String(i.variant_id) !== String(variante)) return;
          if (!m[i.key]) { m[i.key] = { key: i.key, quantidade: 0, props: p, item: i }; ordem.push(i.key); }
          m[i.key].quantidade += i.quantity;
        });
        var g = ordem.map(function (k) { return m[k]; });
        return {
          cart: cart,
          todas: g,
          pagas: g.filter(function (x) { return x.props && !x.props.bxgy; }),
          brindes: g.filter(function (x) { return x.props && x.props.bxgy; }),
          presentes: presentes,
        };
      });
  }
  function presentesDa(l, deal) { return l.presentes.filter(function (x) { return x.props.deal === deal; }); }
  function mudar(chave, quantidade, props) {
    var corpo = { id: chave, quantity: quantidade };
    if (props) corpo.properties = { __kaching_bundles: JSON.stringify(props) };
    return post('cart/change.js', corpo);
  }
  // remove o bundle inteiro: unidades pagas, unidades grátis e as guias de brinde da mesma oferta
  function zerarBundle(variante, deal) {
    return linhasAtuais(variante).then(function (l) {
      return zerar(l.todas.concat(presentesDa(l, deal)).map(function (g) { return g.item; }));
    });
  }
  // As guias de brinde da oferta escolhida, no mesmo grupo das unidades (é assim que o Kaching zera o preço delas).
  // A guia que já está no carrinho é reaproveitada (só trocam as propriedades): tirar e pôr de novo dispararia
  // um AddToCart a cada −. Só entra linha nova quando a oferta nova tem uma guia a mais (no +).
  function conciliarPresentes(bar, grupo, deal, plano, cartInicial) {
    var lista = (bar.presentes || []).filter(function (g) { return !g.soAssinatura || plano; });
    return Promise.all(lista.map(function (g) { return g.variante ? g.variante : varianteDe(g.produto, cartInicial); }))
      .then(function (vs) {
        return fetch(raiz + 'cart.js').then(function (r) { return r.json(); }).then(function (cart) {
          var existentes = cart.items.filter(function (i) { var p = propsDe(i); return p && p.gift && p.deal === deal; });
          var usados = {}, trocas = [], novos = [];
          lista.forEach(function (g, n) {
            if (!vs[n]) return;
            var props = { id: grupo, deal: deal, gift: g.id };
            var linha = existentes.find(function (i) { return !usados[i.key] && String(i.variant_id) === String(vs[n]); });
            if (linha) { usados[linha.key] = true; trocas.push({ key: linha.key, q: g.q || 1, props: props }); }
            else novos.push({ id: Number(vs[n]), quantity: g.q || 1, properties: { __kaching_bundles: JSON.stringify(props) } });
          });
          return zerar(existentes.filter(function (i) { return !usados[i.key]; }))
            .then(function () {
              return trocas.reduce(function (p, t) { return p.then(function () { return mudar(t.key, t.q, t.props); }); }, Promise.resolve());
            })
            .then(function () { return novos.length ? adicionar(novos) : null; });
        });
      });
  }
  function restaurar(variante, deal, original) {
    return zerarBundle(variante, deal).then(function () {
      return adicionar(original.map(function (g) {
        var o = { id: g.item.variant_id, quantity: g.quantidade, properties: g.item.properties || {} };
        if (g.item.selling_plan_allocation) o.selling_plan = g.item.selling_plan_allocation.selling_plan.id;
        return o;
      }));
    });
  }

  var ocupado = false;
  function trocar(li, itens, escolher) {
    if (ocupado) return;
    ocupado = true;
    li.querySelectorAll('.loading__spinner').forEach(function (el) { el.classList.remove('hidden'); });
    var lista = document.getElementById('CartDrawer-CartItems');
    if (lista) lista.classList.add('cart__items--disabled');
    var variante = li.getAttribute('data-pl-variant'), original = [];
    linhasAtuais(variante)
      .then(function (l) {
        var base = l.pagas[0] && l.pagas[0].props;
        if (!base || !base.deal || !base.pp || l.pagas.length + l.brindes.length !== l.todas.length) throw new Error('carrinho fora do padrão do Kaching');
        var presentesAntigos = presentesDa(l, base.deal), cartInicial = l.cart;
        original = l.todas.concat(presentesAntigos);
        var total = l.todas.reduce(function (s, g) { return s + g.quantidade; }, 0);
        var plano = l.pagas[0].item.selling_plan_allocation ? l.pagas[0].item.selling_plan_allocation.selling_plan.id : null;
        return ofertas(base.deal).then(function (bars) {
          if (!bars) throw new Error('sem ofertas');
          var alvo = escolher(bars, total); // null = remover o bundle · undefined = já está no limite
          if (alvo === undefined) return;
          if (alvo === null) return zerarBundle(variante, base.deal);
          var novo = propsDaOferta(alvo, base);
          function semExtras() {
            return linhasAtuais(variante).then(function (a) {
              var extra = a.pagas[1] || a.brindes[1];
              return extra ? mudar(extra.key, 0).then(semExtras) : a;
            });
          }
          return semExtras()
            .then(function (a) { return mudar(a.pagas[0].key, novo.pagas, novo.paga); })
            .then(function () { return linhasAtuais(variante); })
            .then(function (a) {
              var b = a.brindes[0];
              if (b && novo.brindes > 0) return mudar(b.key, novo.brindes, novo.brinde);
              if (b) return mudar(b.key, 0);
              if (novo.brindes > 0) {
                var o = { id: Number(variante), quantity: novo.brindes, properties: { __kaching_bundles: JSON.stringify(novo.brinde) } };
                if (plano) o.selling_plan = plano;
                return adicionar([o]);
              }
            })
            // as guias acompanham a oferta: presas ao grupo antigo, passariam a ser cobradas
            .then(function () { return conciliarPresentes(alvo, novo.grupo, base.deal, plano, cartInicial); })
            .catch(function (e) { return restaurar(variante, base.deal, original).then(function () { throw e; }); });
        });
      })
      .then(function () { return atualizar(itens); })
      .catch(function () { location.reload(); })
      .then(function () { ocupado = false; });
  }

  document.addEventListener(
    'click',
    function (e) {
      var t = e.target;
      if (!t || !t.closest) return;
      var li = t.closest('#CartDrawer .cart-item[data-pl-bundle]');
      if (!li) return;
      var itens = li.closest('cart-drawer-items');
      if (!itens) return;
      var mais = t.closest('.quantity__button[name="plus"]');
      var menos = t.closest('.quantity__button[name="minus"]');
      var lixo = t.closest('cart-remove-button');
      if (!mais && !menos && !lixo) return;
      e.preventDefault();
      e.stopImmediatePropagation();
      trocar(li, itens, function (bars, total) {
        if (lixo) return null;
        var ordem = bars.slice().sort(function (a, b) { return unidades(a) - unidades(b); });
        if (mais) return ordem.find(function (b) { return unidades(b) > total; });
        return ordem.reverse().find(function (b) { return unidades(b) < total; });
      });
    },
    true
  );
})();

/* ---------- barra fixa de compra ---------- */
(function () {
  function iniciar() {
    var sticky = document.querySelector('[data-pl-sticky]');
    if (!sticky || sticky.__pl) return;
    sticky.__pl = true;
    var principal = document.querySelector('product-form .product-form__submit');
    if (!principal) return;
    var botao = sticky.querySelector('.pl-sticky__btn');
    document.body.appendChild(sticky);
    var passou = false, visivel = false;
    function aplicar() {
      var gavetaAberta = !!document.querySelector('cart-drawer.active, cart-drawer.animate');
      var mostrar = passou && !gavetaAberta;
      if (mostrar === visivel) return;
      visivel = mostrar;
      sticky.classList.toggle('is-visivel', mostrar);
      document.body.classList.toggle('pl-sticky-ativo', mostrar);
      sticky.setAttribute('aria-hidden', mostrar ? 'false' : 'true');
      botao.tabIndex = mostrar ? 0 : -1;
    }
    // rolagem (e não IntersectionObserver): um salto direto para o topo também precisa esconder a barra
    var pendente = false;
    function medir() {
      pendente = false;
      passou = principal.getBoundingClientRect().bottom < 0;
      aplicar();
    }
    window.addEventListener('scroll', function () {
      if (pendente) return;
      pendente = true;
      requestAnimationFrame(medir);
    }, { passive: true });
    medir();
    var gaveta = document.querySelector('cart-drawer');
    if (gaveta) new MutationObserver(aplicar).observe(gaveta, { attributes: true, attributeFilter: ['class'] });
    botao.addEventListener('click', function () { principal.click(); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', iniciar);
  else iniciar();
})();

/* ---------- página /cart: o mesmo carrinho da gaveta, aberto na página ----------
   A seção pl-carrinho-pagina move a gaveta para dentro da página (classe pl-pagina). Aqui ela deixa de
   "abrir" e "fechar": o ícone do carrinho só volta ao topo e a rolagem da página nunca é travada. */
(function () {
  function iniciar() {
    var gaveta = document.querySelector('cart-drawer.pl-pagina');
    if (!gaveta || gaveta.__plPagina) return;
    gaveta.__plPagina = true;
    gaveta.open = function () { window.scrollTo({ top: 0, behavior: 'smooth' }); };
    gaveta.close = function () {};
    document.body.classList.remove('overflow-hidden');
    // a página do carrinho do Dawn avisa "carrinho visto" ao carregar; a gaveta só avisava ao abrir
    var itens = gaveta.querySelector('cart-drawer-items');
    if (itens && typeof itens.dispatchViewEvent === 'function') {
      try { itens.dispatchViewEvent(); } catch (e) {}
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', iniciar);
  else iniciar();
})();

/* ---------- botão "voltar ao topo" ---------- */
(function () {
  function iniciar() {
    if (document.querySelector('.pl-topo')) return;
    // na página /cart o rodapé do carrinho fica preso embaixo; o botão cobriria o "Effettua l'ordine"
    if (document.querySelector('cart-drawer.pl-pagina')) return;
    var b = document.createElement('button');
    b.type = 'button';
    b.className = 'pl-topo';
    b.setAttribute('aria-label', 'Torna su');
    b.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M12 19V5M5 12l7-7 7 7"/></svg>';
    b.addEventListener('click', function () { window.scrollTo({ top: 0, behavior: 'smooth' }); });
    document.body.appendChild(b);
    var pendente = false;
    function medir() { pendente = false; b.classList.toggle('is-visivel', window.scrollY > 400); }
    window.addEventListener('scroll', function () { if (!pendente) { pendente = true; requestAnimationFrame(medir); } }, { passive: true });
    medir();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', iniciar);
  else iniciar();
})();
